import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_ARTICLE_INFOS_FOURNISSEUR_REQUEST: 'FETCH_ARTICLE_INFOS_FOURNISSEUR_REQUEST',
    FETCH_ARTICLE_INFOS_FOURNISSEUR_SUCCESS: 'FETCH_ARTICLE_INFOS_FOURNISSEUR_SUCCESS',
    FETCH_ARTICLE_INFOS_FOURNISSEUR_FAILURE: 'FETCH_ARTICLE_INFOS_FOURNISSEUR_FAILURE'
};


/**
 * FETCH_ARTICLE_INFOS_FOURNISSEUR
 * ActionCreator pour obtenir les information sur le fournisseur
 */
const fetchArticleInfosFournisseurRequest = () => ({ type: Actions.FETCH_ARTICLE_INFOS_FOURNISSEUR_REQUEST });
const fetchArticleInfosFournisseurSuccess = infos => ({ type: Actions.FETCH_ARTICLE_INFOS_FOURNISSEUR_SUCCESS, infos });
const fetchArticleInfosFournisseurFailure = error => ({ type: Actions.FETCH_ARTICLE_INFOS_FOURNISSEUR_FAILURE, error });

export const fetchArticleInfosFournisseur = (codeArticle) => async (dispatch) => {
    dispatch(fetchArticleInfosFournisseurRequest());

    try {
        let response = await axios.get(`api/articles-gestion/${codeArticle}/infos-fournisseur`);
        dispatch(fetchArticleInfosFournisseurSuccess(response.data));
    } catch (error) {
        console.error('fetchArticleInfosFournisseur : ', JSON.stringify(error));
        dispatch(fetchArticleInfosFournisseurFailure(error));
    }
};